<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CheckModal from "@/components/CheckModal";
import medicionSeveridadAPI from "../../../services/standards/medicionSeveridad/medicionSeveridadAPI";
import { downloadLineChartImage } from "@/utils/helpers/chartImage";

export default {
  page: {
    title: "3.3.1 Medición de la severidad de la accidentalidad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      title: "3.3.1 Medición de la severidad de la accidentalidad",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.1 Medición de la severidad de la accidentalidad",
          active: true,
        },
      ],

      years: [],
      meses: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      busyDays: 0,
      selected: null,

      chartOptions: {
        lineSmooth: false,
      },

      medicionAnual: {
        start_year: currentYear,
        end_year: currentYear,
      },
      showAnnualGraph: null,
      graphAnnualData: { labels: [], series: [[]] },
      isGenerating: false,

      medicionMensual: {
        year: currentYear,
      },
      monthlyTable: {},

      showMonthlyGraph: null,
      graphMonthlyData: { labels: [], series: [[]] },
      isGeneratingMonthly: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      token: this.$store.state.auth.user.token || null,
    }
  },
  computed: {
    buttonClass() {
      return this.isGenerating ? "btn-danger" : "btn-primary";
    },
    buttonText() {
      return this.isGenerating ? "Limpiar" : "Generar reporte";
    },
    buttonClassMonthly() {
      return this.isGeneratingMonthly ? "btn-danger" : "btn-primary";
    },
    buttonTextMonthly() {
      return this.isGeneratingMonthly ? "Limpiar" : "Generar reporte";
    },
    orderedMonths() {
      const monthsOrder = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
      ];
      return monthsOrder.filter(mes => this.monthlyTable?.[mes]);
    }
  },
  methods: {
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false;
        }
        else {
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        }
        const permissions = this.$store.state.auth.info.permissions;
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        return enabled && role ? true : false;
      }
      else {
        return false;
      }
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;

      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page;
    },

    goBack() {
      this.$router.go(-1);
    },

    toggleReport() {
      if (this.isGenerating) {
        this.resetForm();
      } else {
        this.generateReport();
      }
    },

    resetForm() {
      this.medicionAnual.start_year = new Date().getFullYear();
      this.medicionAnual.end_year = new Date().getFullYear();
      this.showAnnualGraph = false;
      this.isGenerating = false;
      this.$emit("reset-form");
    },

    generateReport() {
      this.showAnnualGraph = true;
      this.isGenerating = true;
      this.$emit("generate-report");
      this.busyDaysData();
      this.reportAnual();
    },

    async reportAnual() {
      try {
        await medicionSeveridadAPI.getMedicionSeveridadAnual(this.companyID, this.medicionAnual)
          .then((response) => {
            const dataResponse = response;

            // Inicializa graphAnnualData
            this.graphAnnualData = {
              labels: [],
              series: [[]],
            };

            // Itera sobre dataResponse y agrega los datos a graphAnnualData
            for (let i = 0; i < dataResponse.length; i++) {
              this.graphAnnualData.labels.push(dataResponse[i]['Año']);
              this.graphAnnualData.series[0].push(dataResponse[i]['severidad_accidentalidad']);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error('Error fetching annual report data:', error);
      }
    },

    toggleReportMonthly() {
      if (this.isGeneratingMonthly) {
        this.resetFormMonthly();
      } else {
        this.generateReportMonthly();
      }
    },

    resetFormMonthly() {
      this.medicionMensual.year = new Date().getFullYear();
      this.showMonthlyGraph = false;
      this.isGeneratingMonthly = false;
      this.$emit("reset-form");
    },

    generateReportMonthly() {
      this.showMonthlyGraph = true;
      this.isGeneratingMonthly = true;
      this.$emit("generate-report");
      this.busyDaysData();
      this.reportMensual();
    },

    async reportMensual() {
      try {
        const response = await medicionSeveridadAPI.getMedicionSeveridadMensual(this.companyID, this.medicionMensual);
        if (response) {
          const dataResponse = response;
          this.monthlyTable = response;

          // Inicializa graphMonthlyData
          this.graphMonthlyData = {
            labels: [],
            series: [[]],
          };

          // Array con los nombres de los meses en orden
          const monthsOrder = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
          ];

          // Itera sobre monthsOrder y asigna los valores correspondientes
          for (let month of monthsOrder) {
            this.graphMonthlyData.labels.push(month.charAt(0).toUpperCase() + month.slice(1)); // Capitaliza el primer carácter
            const monthData = dataResponse[month];
            const severity = monthData ? monthData.severidad_accidentalidad : 0;
            this.graphMonthlyData.series[0].push(severity); // Asigna el valor de severidad_accidentalidad o 0 si no existe
          }

        }
      } catch (error) {
        console.error('Error fetching monthly report data:', error);
      }
    },

    async busyDaysData() {
      try {
        let data = {
          start_year: null,
          end_year: null,
          period: null,
          companies_id: this.companyID,
        };

        if (this.isGenerating) { // Si se está generando el reporte anual
          data.start_year = this.medicionAnual.start_year;
          data.end_year = this.medicionAnual.end_year;
          data.period = 'annual';
        } else if (this.isGeneratingMonthly) { // Si se está generando el reporte mensual
          data.start_year = this.medicionMensual.year;
          data.end_year = this.medicionMensual.year;
          data.period = 'monthly';
        }

        const response = await medicionSeveridadAPI.getBusyDays(data);
        this.busyDays = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async print() {
      try {
        medicionSeveridadAPI
          .getExcel(this.companyID, this.medicionMensual.year)
          .then((response) => {
            window.location.href = response;
          });
      } catch (error) {
        console.log(error);
      }
    },

    downloadMonthlyChartImage() {
      downloadLineChartImage(
        this.graphMonthlyData.labels,
        [{ data: this.graphMonthlyData.series[0], label: "Severidad mensual" }],
        `severidad-mensual-${this.medicionMensual.year}`
      );
    },

    downloadAnnualChartImage() {
      downloadLineChartImage(
        this.graphAnnualData.labels,
        [{ data: this.graphAnnualData.series[0], label: "Severidad anual" }],
        `severidad-anual-${this.medicionAnual.start_year}-${this.medicionAnual.end_year}`
      );
    },

  },
  mounted() {
    this.rangeYear();
  },
}
</script>
<template>

  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-md-6 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Este indicador mide la cantidad de días perdidos por concepto de accidentes laborales,
                    relacionandolos días de incapacidad y los días cargados por los accidentes mortales o con pérdida de
                    la capacidad laboral.
                  </p>
                  <p class="text-justify">
                    El responsable de la implementación deberá definir la meta mensual y anual, además el responsable de
                    la medición y las personas que deben conocer el resultado.
                  </p>
                  <p class="text-justify">
                    En este ítem podrá encontrar la ficha del indicador de severidad de la accidentalidad, además
                    visualizar el cálculo de este en un periodo determinado.
                  </p>
                </CheckModal>
              </div>

              <div class="col-6 text-right m-b-0">
                <button @click="goPage(`/forms/estandares/${companyID}/medicion-severidad`)"
                  class="btn btn-primary mx-1">
                  <span class="btn-label"> </span> Parametrizar periodos
                </button>
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

            </div>

            <hr />

            <div class="row pt-3">
              <b-form-group label="Seleccionar Periodicidad" label-for="¿Evaluada el ultimo año?" inline
                class="col-sm-4 pl-3">
                <label class="mr-2 pl-sm-2 pl-md-0"> Mensual </label>
                <input type="radio" :value="2" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" v-model="selected" />
                <label class="mr-2"> Anual </label>
                <input type="radio" style="color: #666" :value="1" class="mb-2 mr-sm-2 mb-sm-0" label="accidente"
                  v-model="selected" />
              </b-form-group>
            </div>

            <form class="row pt-3 pl-2" v-if="selected === 2" @submit.prevent="reportMensual">
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Seleccione el año">
                <b-form-select class="col-md-8 form-control" v-model="medicionMensual.year">
                  <b-form-select-option v-for="item in years" :value="item" v>
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-6 col-sm-12">
                <button @click="toggleReportMonthly" type="button" class="btn mt-3" :class="buttonClassMonthly">
                  {{ buttonTextMonthly }}
                </button>
              </div>

              <div class="col-md-4 col-sm-12 text-right m-b-0 d-flex justify-content-center align-items-center">
                <button @click="print" type="button" class="btn btn-primary mx-1" id="tooltip">
                  <span class="btn-label"><i class="bx bx-download"></i></span>Descargar tabla a excel
                </button>
                <b-tooltip target="tooltip" placement="left">
                  Descargar reporte
                </b-tooltip>
              </div>

              <div v-if="showMonthlyGraph" class="form-row col-12 pt-2 tablaExcel">
                <div class="table-responsive pt-4 px-5" v-if="getRole('Consultar')">
                  <table class="pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                    <thead class="bg-primary text-light">
                      <tr>
                        <th class="text-center align-middle">Periodo</th>
                        <th class="text-center align-middle">Meta</th>
                        <th class="text-center align-middle">Días incapacidad</th>
                        <th class="text-center align-middle">Días cargados</th>
                        <th class="text-center align-middle">Total colaboradores mes</th>
                        <th class="text-center align-middle">Indicador de severidad de la accidentalidad</th>
                        <th class="text-center align-middle">Cumple</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="mes in orderedMonths" :key="mes">
                        <td class="text-center align-middle">{{ mes }}</td>
                        <td class="text-center align-middle">
                          {{ monthlyTable[mes]?.meta ?? 0 }}
                        </td>
                        <td class="text-center align-middle">
                          {{ monthlyTable[mes]?.dias_incapacidad ?? 0 }}
                        </td>
                        <td class="text-center align-middle">
                          {{ monthlyTable[mes]?.dias_cargados ?? 0 }}
                        </td>
                        <td class="text-center align-middle">
                          {{ monthlyTable[mes]?.total_colaboradores_mes ?? 0 }}
                        </td>
                        <td class="text-center align-middle">
                          {{ monthlyTable[mes]?.severidad_accidentalidad ?? 0 }}
                        </td>
                        <td :class="{ 'bg-red': monthlyTable[mes]?.cumple === 'NO' }" class="text-center align-middle">
                          {{ monthlyTable[mes]?.cumple ?? 'NO' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="showMonthlyGraph" class="col-lg-12 pt-3">
                <div class="tittle-graph"><strong>Esta gráfica representa el resultado de severidad Mensual de la
                    accidentalidad</strong></div>
                <div class="text-right mb-2">
                  <button @click="downloadMonthlyChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica frecuencia de accidentalidad mensual</h4>
                    <ul>
                      <li style="color: #00707f">Severidad mensual</li>
                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="graphMonthlyData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>
            </form>

            <form class="row pt-3 pl-2" v-if="selected === 1" @submit.prevent="reportAnual">
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Inicio">
                <b-form-select required class="col-md-8 form-control" v-model="medicionAnual.start_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group id="cycle" label-for="cycle" class="col-md-2 px-2" label="Fin">
                <b-form-select required class="col-md-8 form-control" v-model="medicionAnual.end_year">
                  <b-form-select-option v-for="item in years" :value="item">
                    {{ item }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>

              <div class="col-md-6 col-sm-12">
                <button @click="toggleReport" type="button" class="btn mt-3" :class="buttonClass">
                  {{ buttonText }}
                </button>
              </div>

              <div v-if="showAnnualGraph" class="col-lg-12 pt-3">
                <div class="tittle-graph"><strong>Esta gráfica representa el resultado de severidad Anual de la
                    accidentalidad</strong></div>
                <div class="text-right mb-2">
                  <button @click="downloadAnnualChartImage" type="button" class="btn btn-primary mx-1">
                    <span class="btn-label"><i class="bx bx-download"></i></span>Descargar gráfica
                  </button>
                </div>
                <div class="card">
                  <div class="card-body" dir="ltr">
                    <h4 class="header-title">Gráfica frecuencia de accidentalidad anual</h4>
                    <ul>
                      <li style="color: #00707f">Severidad anual</li>
                    </ul>
                    <p class="sub-header"></p>

                    <Chartist ratio="ct-chart" :data="graphAnnualData" :options="chartOptions" type="Line"></Chartist>
                  </div>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>



  </Layout>

</template>
<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}

.bg-red {
  background-color: red;
  color: white;
}

.tittle-graph {
  font-size: 1.2rem;
  font-weight: bold;
  color: #00707f;
}
</style>